import {
  Button,
  Card,
  CardContent,
  CardHeader,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  MenuItem,
  Stack,
  TextField,
} from "@mui/material";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import FactCheckIcon from "@mui/icons-material/FactCheck";

import EquipmentMasterCatalogApi from "../../../../../infrastructure/api/equipmentMasterCatalog";
import BreadcrumbsComponent from "../../../../components/shared/breadcrumbs";
import EnhancedTable from "../../../../components/shared/table";

// EqmItemRequestStatus: Approved=4, NeedsCorrection=5, Rejected=6
const DECISIONS = [
  { value: 4, label: "تأیید و ایجاد تجهیز مرجع" },
  { value: 5, label: "نیازمند اصلاح" },
  { value: 6, label: "رد درخواست" },
];

const EquipmentItemRequests = () => {
  const [rows, setRows] = useState([]);
  const [brands, setBrands] = useState([]);
  const [open, setOpen] = useState(false);
  const [review, setReview] = useState({
    requestId: 0,
    decision: 4,
    reviewNote: "",
    modelName: "",
    shortTitle: "",
    brandId: "",
    defaultUnit: "",
  });

  const load = () =>
    EquipmentMasterCatalogApi.getItemRequests().then((r) => setRows(r?.data || []));

  useEffect(() => {
    load();
    EquipmentMasterCatalogApi.getBrands(false).then((r) => setBrands(r?.data || []));
  }, []);

  const openReview = (row) => {
    setReview({
      requestId: row.id,
      decision: 4,
      reviewNote: "",
      modelName: row.modelText || "",
      shortTitle: `${row.brandText || ""} ${row.modelText || ""}`.trim(),
      brandId: "",
      defaultUnit: "",
    });
    setOpen(true);
  };

  const submitReview = async () => {
    const payload = {
      ...review,
      brandId: review.brandId ? Number(review.brandId) : null,
    };
    const res = await EquipmentMasterCatalogApi.reviewItemRequest(payload);
    if (res.ok) {
      toast.success("بررسی ثبت شد");
      setOpen(false);
      load();
    } else toast.error(res.message || "خطا");
  };

  const headCells = [
    {
      id: "requesterTypeTitle",
      label: "درخواست‌دهنده",
      render: (value) => <Chip size="small" variant="outlined" label={value || "—"} />,
    },
    { id: "categoryTitle", label: "دسته" },
    { id: "brandText", label: "برند (متن)" },
    { id: "modelText", label: "مدل (متن)" },
    {
      id: "statusTitle",
      label: "وضعیت",
      render: (value) => <Chip size="small" label={value} />,
    },
    { id: "createOn", label: "تاریخ", type: "date" },
  ];

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <BreadcrumbsComponent />
      </Grid>
      <Grid item xs={12}>
        <Card>
          <CardHeader title="درخواست‌های افزودن تجهیز به کاتالوگ مرجع" />
          <CardContent>
            <EnhancedTable
              rowKey={"id"}
              rows={rows}
              headCells={headCells}
              pageSize={100}
              actions={[
                {
                  icon: <FactCheckIcon sx={{ width: "1rem", height: "1rem" }} />,
                  onClick: openReview,
                  color: "primary",
                  tooltip: "بررسی",
                },
              ]}
            />
          </CardContent>
        </Card>
      </Grid>

      <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth="sm">
        <DialogTitle>بررسی درخواست تجهیز</DialogTitle>
        <DialogContent>
          <Stack spacing={2} sx={{ mt: 1 }}>
            <TextField
              select
              size="small"
              label="تصمیم"
              value={review.decision}
              onChange={(e) => setReview((r) => ({ ...r, decision: Number(e.target.value) }))}
            >
              {DECISIONS.map((d) => (
                <MenuItem key={d.value} value={d.value}>
                  {d.label}
                </MenuItem>
              ))}
            </TextField>

            {review.decision === 4 && (
              <>
                <TextField
                  size="small"
                  label="مدل نهایی *"
                  value={review.modelName}
                  onChange={(e) => setReview((r) => ({ ...r, modelName: e.target.value }))}
                />
                <TextField
                  size="small"
                  label="عنوان کوتاه"
                  value={review.shortTitle}
                  onChange={(e) => setReview((r) => ({ ...r, shortTitle: e.target.value }))}
                />
                <TextField
                  select
                  size="small"
                  label="برند"
                  value={review.brandId}
                  onChange={(e) => setReview((r) => ({ ...r, brandId: e.target.value }))}
                >
                  <MenuItem value="">—</MenuItem>
                  {brands.map((b) => (
                    <MenuItem key={b.id} value={b.id}>
                      {b.name}
                    </MenuItem>
                  ))}
                </TextField>
                <TextField
                  size="small"
                  label="واحد پیش‌فرض"
                  value={review.defaultUnit}
                  onChange={(e) => setReview((r) => ({ ...r, defaultUnit: e.target.value }))}
                />
              </>
            )}

            <TextField
              size="small"
              multiline
              minRows={2}
              label="یادداشت بررسی"
              value={review.reviewNote}
              onChange={(e) => setReview((r) => ({ ...r, reviewNote: e.target.value }))}
            />
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>انصراف</Button>
          <Button variant="contained" onClick={submitReview}>
            ثبت بررسی
          </Button>
        </DialogActions>
      </Dialog>
    </Grid>
  );
};

export default EquipmentItemRequests;
